import logoLightMode from '../../../assets/images/logo-light-mode.svg';
import logoDarkMode from '../../../assets/images/logo-dark-mode.svg';
import { useState } from 'react';

type CypherLeakLogoProps = {
  src?: string; // Optional prop for custom image source
  alt?: string;
};

const CypherLeakLogo = ({ src, alt }: CypherLeakLogoProps) => {
  const [lightImgSrc, setLightImgSrc] = useState(src || logoLightMode);
  const [darkImgSrc, setDarkImgSrc] = useState(src || logoDarkMode);
  // If there is an error loading the provided `src`, fall back to default image
  const onLightError = () => setLightImgSrc(logoLightMode);
  const onDarkError = () => setDarkImgSrc(logoDarkMode);

  

  return (
    <>
      <img className="logo-mode-dark" src={darkImgSrc} alt={alt || 'Cypherleak logo'} onError={onDarkError} />
      <img src={lightImgSrc} alt={alt || 'Cypherleak logo'} onError={onLightError} />
    </>
  );
}

export default CypherLeakLogo